// extracted by mini-css-extract-plugin
export default {"component":"Z4wBx"};